import React from "react";
import { connect } from "react-redux";


import { IcChevrDown, IcChevrLeft, IcFilter, IcResetFilter} from "../../../common/svg";
import { HOME } from "../../../../constant/routes";



class CSSearchFilter extends React.Component {
	constructor(props) {
		super(props);
    }

	toggleFilter = () => {
		this.props.toggleFilter()
	}

	toggleSearching = () => {
		this.props.toggleSearching()
	}

	resetFilter = () => {
		this.props.resetFilter()
	}


	render() {
		const {  filter, customFilterConfig, visible } = this.props;
		// const hasFilter = this.props.hasFilter(filter, customFilterConfig)
		const { address, timeCS } = this.props.csFinding.filter;
		
		return (
			<div className={`finding-filter-mobile-section fixed ${visible ? "" : "scroll-top"}`}> 
				<div className="m-container"> 
					<a href={HOME} className="wrap-svg back">
						<IcChevrLeft />
					</a>
					<div className="finding-mobile" > 
						{/* onClick={this.toggleSearching} */}
						<span className="date-time">
							Địa điểm
						</span>
						<div className="address" > 
						
								<p>{address}</p>
							
					
							{/* <div className="wrap-svg">
								<IcChevrDown />
							</div> */}
						</div>
			
					{/* <span className="date-time">
						<span className="select">{timeCS == 12 ? `${timeCS} năm` : timeCS == 0 ? 'Tùy chỉnh' : `Thời gian thuê: ${timeCS} tháng`}</span>
					</span> */}
				</div>
				<div className="filter-mobile"> 
			
					<div className="filter-mobile__item" onClick={this.toggleFilter}> 
						<div className="wrap-svg">
							<IcFilter />
						</div>
					
					</div>
				</div>
			</div>
		</div> 
		)
	}
}

function mapState(state) {
	return {
		csFinding: state.csFinding,
	};
}

CSSearchFilter = connect(mapState)(CSSearchFilter);

export default CSSearchFilter




